import { RolesGroup } from "./RolesGroup";
import type { IRole } from "./IRole";

export class RolesGroupFunctions {
    public static RolesGroup: (Role: IRole) => RolesGroup = (role: IRole) => {
        const globalRoles = ["Developer", "SysAdmin", "GlobalOperationsMonitoring"];
        const partnerRoles = ["PartnerAdmin", "PartnerUser", "PartnerOperator"];
        const siteRoles = ["SiteAdmin", "SiteUser", "LimitedSiteUser", "ExceptionsOnly", "VideoExportOnly"];

        if (globalRoles.some((name) => name === role.name)) {
            return RolesGroup.Global;
        }
        if (partnerRoles.some((name) => name === role.name)) {
            return RolesGroup.Partner;
        }
        if (siteRoles.some((name) => name === role.name)) {
            return RolesGroup.Site;
        }
        return undefined;
    };
}
